import { render } from "./DeactivateModal.vue?vue&type=template&id=1e406122"
import script from "./DeactivateModal.vue?vue&type=script&lang=js"
export * from "./DeactivateModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__